module.exports = __webpack_public_path__ + "static/media/Jacob Moses Headshot_1607632929595.43424674.jpeg";